import $ from 'jquery';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import Swipeable from 'react-swipeable';
import Modal from '../../components/bootstrap4/Modal';
import Loading from '../../components/Loading';
import LazyLoadImage from '../../components/LazyLoadImage';
import SessionManager from '../../routes/SessionManager';
import ZoneHistoryImage from './ZoneHistoryImage';
import ZoneSensorBattery from './ZoneSensorBattery';
import video_icon from '../../assets/img/video-icon.png';
import no_image from './../../assets/img/no-image.png';
import { Tooltip } from 'antd';
import XMLParser from 'react-xml-parser';
import AppConfig from '../../config/AppConfig';
import Toastr from 'toastr';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

const COLORS = { 'WORK': '#888888', 'OFFWORK': '#2d3138eb', 'PEOPLE': 'rgba(9,109,217)', 'LINE': '#eeeeee', 'VEHICLE': 'rgb(255, 165, 0)' };
const ZoneHistoryCarousel = (props) => {
  const video_ref = useRef(null);

  const [slidePos, setSlidePos] = useState(0);
  const [labels, setLabels] = useState(null);
  const [datasets, setDatasets] = useState(null);
  const [holidays, setHolidays] = useState([]);
  const [thumbnailWidth, setThumbnailWidth] = useState(100);
  const [holidayFetchComplete, setHolidayFetchComplete] = useState(false);
  const [maxSize, setMaxSize] = useState(null);
  const [history_recs, setHistoryRecs] = useState(null);
  const [s3CacheKey, setS3CacheKey] = useState(null);
  const s3CacheKeyRef = useRef(null);
  const historyRecsRef = useRef(null);
  const lastRequestedRangeRef = useRef({ from: -1, to: -1 });
  const currentScrollIndexRef = useRef(null);
  const pendingAiScrollRef = useRef(null);
  const thumbnailWidthRef = useRef(100);
  const fetchAllInProgressRef = useRef(false);
  const syncingScrollRef = useRef(false);


  const pageSize = 100;

  let sessionMgr = new SessionManager();
  let user = sessionMgr.readCookie('user');

  let timezone = user.site_selected.site_iana_timezone;
  if (!timezone)
    timezone = moment.tz.guess();

  const [date, setDate] = useState(user.ai_event ? moment.tz(user.ai_event.sec_timestamp * 1000, timezone).format('YYYY-MM-DD') : props.date);
  let is_axis_camera = user.zone_selected && user.zone_selected.location_device_type && ['axis', 'uniview'].includes(user.zone_selected.location_device_type);

  //console.log('ai_event sec_timestamp:', user.ai_event ? user.ai_event.sec_timestamp : null);
  const ai_event_sec_timestamp = user.ai_event ? user.ai_event.sec_timestamp : null;
  // Keep refs in sync so scroll/click handlers always see current values
  useEffect(() => { s3CacheKeyRef.current = s3CacheKey; }, [s3CacheKey]);
  useEffect(() => { historyRecsRef.current = history_recs; }, [history_recs]);
  useEffect(() => { thumbnailWidthRef.current = thumbnailWidth; }, [thumbnailWidth]);

  useEffect(() => {
    if (props && holidayFetchComplete) {
      setDate(props.date);
    }
    calcualteThumbnailDimensions();
    getHolidaysList();
  }, [props]);

  useEffect(() => {
    if (props && holidayFetchComplete) {
      fetchZoneHistory();
    }
  }, [date]);

  let getHolidaysList = async (attempts = 3) => {
    let holiday_config = await AppConfig.getConfigParameter('holidays', 'holidays');
    if (!holiday_config) {
      if (attempts > 0) {
        setTimeout(() => {
          getHolidaysList(--attempts);
        }, 3000);
      }
    } else {
      let site_id = user.site_selected.site_id;
      let holidays = [];
      for (let h of ['default', String(site_id)])
        if (holiday_config[h])
          holidays = holidays.concat(holiday_config[h].filter(x => {
            if (h !== 'default')
              x.site_level = true;
            return x.exclude ? !x.exclude.includes(String(site_id)) : true;
          }));

      //console.log('Holidays for site ' + site_id, holidays);
      setHolidays(holidays);
      setHolidayFetchComplete(true);
    }
  }

  useEffect(() => {
    if (holidayFetchComplete) {
      refreshZoneHistory();
    }
  }, [holidayFetchComplete]);

  // Plain JS scroll sync — registered once on mount.
  // Uses syncingScrollRef (shared with doInitialScroll) to suppress echo scrolls.
  useEffect(() => {
    let scrollTimeout;
    let lastScrollLeft = {};      // keyed 'thumb' / 'chart'

    const onScroll = () => { };

    const debouncedScroll = () => { clearTimeout(scrollTimeout); scrollTimeout = setTimeout(onScroll, 200); };

    const isSlider = (el) => el && el.classList &&
      (el.classList.contains('image-thumbnail-slider') || el.classList.contains('chart_slider'));

    const handleScrollCapture = (e) => {
      const target = e.target;
      if (!isSlider(target)) return;
      if (syncingScrollRef.current) return;

      const isThumb = target.classList.contains('image-thumbnail-slider');
      const key = isThumb ? 'thumb' : 'chart';
      const prev = lastScrollLeft[key];
      const curr = target.scrollLeft;
      lastScrollLeft[key] = curr;

      const peer = isThumb ? $('.chart_slider')[0] : $('.image-thumbnail-slider')[0];
      if (peer) {
        const srcRange = target.scrollWidth - target.offsetWidth;
        const peerRange = peer.scrollWidth - peer.offsetWidth;
        const peerPos = srcRange > 0 ? (curr / srcRange) * peerRange : 0;
        syncingScrollRef.current = true;
        peer.scrollLeft = peerPos;
        lastScrollLeft[isThumb ? 'chart' : 'thumb'] = peerPos;
        setTimeout(() => { syncingScrollRef.current = false; }, 50);
      }

      if (prev !== undefined && curr < prev) debouncedScroll();
    };

    document.addEventListener('scroll', handleScrollCapture, true);

    return () => {
      document.removeEventListener('scroll', handleScrollCapture, true);
      clearTimeout(scrollTimeout);
    };
  }, []);


  let getDVRDetails = () => {
    Toastr.info('Fetching dvr details ...');
    CommonUtils.ajax({
      url: API.AXIS_CAMERA.DVR_DETAILS,
      type: 'POST',
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      headers: {
        user_login: user.user_login,
        user_token: user.user_token
      },
      data: JSON.stringify({ device_id: user.zone_selected.device_id }),
      success: function (response) {
        if (response.status.code === 200) {
          //let disks = null;
          try {
            let dvrDetailsJSON = new XMLParser().parseFromString(response.data);
            let disksInfos = dvrDetailsJSON.getElementsByTagName('disks');

            if (disksInfos && disksInfos.length > 0) {
              if (!disksInfos[0].children || disksInfos[0].children.length === 0) {
                Toastr.error('No DVR disks found');
                return;
              }

              let hasSDDisk = false;
              for (let disksInfo of disksInfos[0].children) {
                let disk = disksInfo.attributes;
                if (disk.hasOwnProperty('readonly') && disk['diskid'] === 'SD_DISK') {
                  hasSDDisk = true;
                  if (disk['readonly'] !== 'no') {
                    Toastr.warning('DVR is locked and needs to be changed to read/write');
                  } else {

                    // console.log({
                    //   'diskid': disk['diskid'],
                    //   'size': disk['totalsize'],
                    //   'free': disk['freesize'],
                    //   'status': disk['readonly']
                    // });

                    if (parseInt(disk['totalsize']) < 200000000) {
                      Toastr.error('Wrong disk size detected.');
                    } else {
                      Toastr.success('A DVR disk is detected and has total size of ' + (disk['totalsize'] / 1000000).toFixed(2) + ' MB');
                    }
                  }
                }
              }
              if (!hasSDDisk) {
                Toastr.error('No DVR disks found');
              }

              sessionMgr.storeCookie('user', { ...user });
            } else {
              Toastr.error('No DVR disks found');
            }

          } catch (e) {
            Toastr.error('Error occurred while fetching DVR details');
          }
          //console.log('dvr-details', disks);

        } else {
          Toastr.error('No DVR found')
        }
      },
      error: function (xhr, status) {
        console.error("Error fetching DVR details", status);
      }
    });
  }

  let refreshZoneHistory = () => {
    fetchZoneHistory();
  }

  let loadBatch = async (pos, _s3CacheKey) => {
    const data = {
      user_login: user.user_login,
      user_token: user.user_token,
      user_type: "user",
      s3_cache_key: _s3CacheKey,
      size: pageSize,
      pos
    };

    try {
      const res = await CommonUtils.ajax({
        url: API.VIDEO.ZONE_HISTORY_ADVANCED,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
      });

      if (res.status && res.data && res.data.code === 'SlowDown') {
        console.warn(`loadBatch SlowDown at pos=${pos}, will retry`);
        return null;
      }

      if (res.status && res.status.code === 200) {
        let batchData = res.data;
        if (batchData && batchData.data_ref) {
          const response = await fetch(batchData.data_ref, { headers: { 'Accept': 'application/json' } });
          batchData = await response.json();
        }
        const newBatch = Array.isArray(batchData) ? batchData : [];
        // Each record carries its own record_id (0-based index from addRecordIds)
        const urlMap = {};
        for (let i = 0; i < newBatch.length; i++) {
          const rec = newBatch[i];
          urlMap[rec.record_id] = {
            image: rec.image,
            image_thumbnail: rec.image_thumbnail,
            video: rec.video
          };
        }
        return urlMap;
      }
    } catch (err) {
      console.error(`Error loading batch pos=${pos}:`, err);
    }
    return null;
  };

  // Render immediately, then fetch signed URLs batch by batch and update incrementally
  let fetchAllRemainingUrls = async (recsArray, _s3CacheKey) => {
    if (fetchAllInProgressRef.current) return;
    fetchAllInProgressRef.current = true;

    const total = recsArray.length;
    // Build start positions from end to beginning (most-recent first).
    // Lambda: slice(pos, pos+size) — pos is the 0-based start index.
    const positions = [];
    for (let pos = total - pageSize; pos > 0; pos -= pageSize) {
      positions.push(pos);
    }
    positions.push(0);

    try {
      for (let i = 0; i < positions.length; i++) {
        let result = null;
        let retries = 3;
        while (retries > 0) {
          result = await loadBatch(positions[i], _s3CacheKey);
          if (result !== null) break;
          retries--;
          if (retries > 0) await new Promise(resolve => setTimeout(resolve, 3000));
        }
        if (result) {
          setHistoryRecs(prev => {
            if (!prev) return prev;
            let changed = false;
            const next = prev.map(rec => {
              const fresh = result[rec.record_id];
              if (!fresh) return rec;
              changed = true;
              return { ...rec, ...fresh };
            });
            return changed ? next : prev;
          });
        }
        if (i < positions.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 500));
        }
      }
    } finally {
      fetchAllInProgressRef.current = false;
    }
  };

  let scrollToPosition = (recordId, source = 'both') => {
    setSlidePos(recordId);

    const doScroll = () => {
      const thumbSlider = $('.image-thumbnail-slider')[0];
      const chartSlider = $('.chart_slider')[0];
      if (!thumbSlider || !chartSlider) return;

      const firstThumb = thumbSlider.querySelector('[id^="img_thumbnail_"]');
      const tw = (firstThumb && firstThumb.offsetWidth > 0) ? firstThumb.offsetWidth : thumbnailWidthRef.current;
      const bw = 50;

      const centerOf = (slider, itemWidth) =>
        recordId * itemWidth - (slider.offsetWidth / 2) + (itemWidth / 2);

      syncingScrollRef.current = true;
      if (source === 'chart') {
        thumbSlider.scrollLeft = centerOf(thumbSlider, tw);
      } else if (source === 'thumb') {
        chartSlider.scrollLeft = centerOf(chartSlider, bw);
      } else {
        thumbSlider.scrollLeft = centerOf(thumbSlider, tw);
        chartSlider.scrollLeft = centerOf(chartSlider, bw);
      }
      setTimeout(() => { syncingScrollRef.current = false; }, 200);
    };

    doScroll();
    setTimeout(doScroll, 50);
  };

  let fetchZoneHistory = () => {

    if (!date) {
      return;
    }

    setSlidePos(0);
    setHistoryRecs(null);
    initialLoadRef.current = true;
    pendingAiScrollRef.current = null;
    lastRequestedRangeRef.current = { from: -1, to: -1 };
    currentScrollIndexRef.current = null;
    fetchAllInProgressRef.current = false;
    setS3CacheKey(null);
    s3CacheKeyRef.current = null;

    var data = {
      customer_id: user.customer_id,
      site_id: (user.user_selected && user.user_selected.site_id) || user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      user_type: "user",
      from: date,
      to: date,
      ai_event_sec_timestamp: ai_event_sec_timestamp,
      location_id: user.zone_selected.location_id,
      timezone: timezone,
      api_new: true,
      tracker_history: true,
      size: pageSize
    };

    CommonUtils.ajax({
      url: API.VIDEO.ZONE_HISTORY_ADVANCED,
      type: 'POST',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: JSON.stringify(data)
    }).then(
      async (res) => {

        if (res.status && res.status.code === 200) {

          if (res.metadata) {
            setS3CacheKey(res.metadata.s3_cache_key);
            s3CacheKeyRef.current = res.metadata.s3_cache_key;
          }

          if (res.data && res.data.data_ref) {
            let response = await fetch(res.data.data_ref, { headers: { 'Accept': 'application/json' } });
            let json = await response.json();
            res.data = json;
          }

          var history_recs = res.data;

          history_recs = history_recs.sort(
            (x, y) => (moment.tz(x.sec_timestamp * 1000, timezone) - moment.tz(y.sec_timestamp * 1000, timezone))
          );

          let recs = {};

          for (let rec of history_recs) {

            if (!rec.dev_timestamp || rec.dev_timestamp === undefined)
              rec.dev_timestamp = rec.sec_timestamp;

            recs[
              moment.tz(rec.sec_timestamp * 1000, timezone)
                .format('YYYY-MM-DD HH:mm:ss')
                .toUpperCase()
            ] = rec;
          }

          COLORS.WORK_PATTERN = createPattern(COLORS.WORK);

          let labels = [];
          let datasets = [];
          let ai_event_pos = -1;
          let slidePos = -1;

          let zone_selected = user.zone_selected;

          let object_detection =
            zone_selected &&
            zone_selected.location_config &&
            zone_selected.location_config.feature_controls &&
            zone_selected.location_config.feature_controls.motion_detection &&
            zone_selected.location_config.feature_controls.motion_detection.enabled;

          // let vehicle_tracking =
          //   zone_selected &&
          //   zone_selected.location_config &&
          //   zone_selected.location_config.feature_controls &&
          //   zone_selected.location_config.feature_controls.vtracking &&
          //   zone_selected.location_config.feature_controls.vtracking.enabled;


          for (let rec of Object.values(recs)) {

            prePopulateTempWeather(rec);

            slidePos++;

            var HHmm = moment.tz(rec.sec_timestamp * 1000, timezone).format('HH:mm').toUpperCase();
            labels.push(HHmm);

            //console.log('rec.sec_timestmap: ' + rec.sec_timestamp + ', label: ' + HHmm + ', ' + rec.record_id);

            let bboxes = [];
            if (rec.bbox_info) {
              try {
                bboxes = JSON.parse(rec.bbox_info);
              } catch (e) {
                console.error('Error parsing bbox_info for rec ' + rec.history_id, e);
              }
            }

            const isWork = isWorkHours(rec.dev_timestamp, user.site_selected);

            const people = bboxes && object_detection !== false ? bboxes.filter(b => b.c === 'person').length : 0;
            const vehicle = object_detection !== false ? (bboxes ? bboxes.filter(b => b.c !== 'person').length : 0) : 0;

            datasets.push({ has_video: rec.has_video ? 1 : null, people, vehicle, is_work_hrs: isWork });
            if (ai_event_sec_timestamp && ai_event_pos === -1) {
              if (
                ai_event_sec_timestamp === String(rec.sec_timestamp) ||
                ai_event_sec_timestamp === rec.dev_timestamp ||
                parseInt(rec.sec_timestamp) > ai_event_sec_timestamp
              ) {
                ai_event_pos = rec.record_id;
              }
            }
          }

          if (ai_event_pos > -1) {
            slidePos = ai_event_pos - 1;
            delete user.ai_event;
            let sessionManagerObj = sessionMgr;
            sessionManagerObj.storeCookie('user', { ...user });
          }

          let max_size = Math.max(...datasets.map(d => d.people), ...datasets.map(d => d.vehicle)) || 3;
          max_size = max_size + 3;

          setMaxSize(max_size);
          setSlidePos(slidePos);
          setLabels(labels);
          setDatasets(datasets);
          const recsArray = Object.values(recs);
          if (ai_event_pos > -1) {
            pendingAiScrollRef.current = ai_event_pos;
          }
          setHistoryRecs(recsArray);
          if (res.metadata && res.metadata.s3_cache_key) {
            fetchAllRemainingUrls(recsArray, res.metadata.s3_cache_key);
          }

          $("[data-toggle='tooltip']").tooltip();
        }

      },
      (res) => {

      }
    );
  };

  let prePopulateTempWeather = (rec) => {
    if (!rec.sensor_info)
      return;

    var sensor_info = JSON.parse(rec.sensor_info);
    sensor_info.filter((x) => {
      if ((x.sensor_id === 'temperature' || x.sensor_id === 'humidity')) {
        rec[x.sensor_id] = (Math.round(x.value_float * 100, 2) / 100);
        return true;
      }
      return false;
    });
  }

  // let onVideoThumbnailClick = (imgCSS) => {
  //   $('.' + imgCSS).trigger('click');
  // }

  let onImageThumbnailClick = (e) => {
    const pos = parseInt(e.target.getAttribute('pos'));
    scrollToPosition(pos, 'thumb');

    ReactGA.event({
      category: 'Navigation',
      action: 'Click ZoneCarousel Item',
      label: 'ZoneCarousel Item in ' + user.zone_selected.location_id + ' for ' + date
    });
  };

  let onNextClick = (e) => {
    $('.bbox').remove();

    let curr_pos = slidePos;
    let max_pos = history_recs.length - 1;

    if (curr_pos === max_pos) {
      curr_pos = 0;
    } else {
      curr_pos = curr_pos + 1;
    }
    setSlidePos(curr_pos);

    ReactGA.event({
      category: 'Navigation',
      action: 'Swipe ZoneCarousel Next Button',
      label: 'ZoneCarousel Next in ' + user.zone_selected.location_id + ' for ' + date
    });
  }

  let onPrevClick = (e) => {
    $('.bbox').remove();

    let curr_pos = slidePos;
    let max_pos = history_recs.length - 1;

    if (curr_pos === 0) {
      curr_pos = max_pos;
    } else {
      curr_pos = curr_pos - 1;
    }
    setSlidePos(curr_pos);

    ReactGA.event({
      category: 'Navigation',
      action: 'Swipe ZoneCarousel Previous Button',
      label: 'ZoneCarousel Previous in ' + user.zone_selected.location_id + ' for ' + date
    });
  }

  let calcualteThumbnailDimensions = () => {
    if ($('#carousel_container').length > 0) {
      let thumbnail_width = ($('#carousel_container')[0].clientWidth / 6);
      setThumbnailWidth(thumbnail_width);
    }
  }

  let applyBoundingBoxes = () => {
    $('.bbox').remove();
    let currentImage = $('#zone-image');
    if (!currentImage[0])
      return;



    if ($(currentImage).parent().width() < 600) {
      $('.video-icon').height(24);
      $('.video-icon').width(32);
    }

    for (let el of $('.align-vc'))
      $(el).css('margin-top', ($(currentImage).parent().height() * 0.5 - $(el).height() * 0.5) + 'px');

    $('.video-btn').css('top', ($(currentImage).parent().height() * 0.5 - $('.video-btn').height() * 0.5) + 'px')

    var historyRec = history_recs && history_recs[slidePos];
    let bb_data = [];
    if (historyRec.bbox_info) {
      try {
        bb_data = JSON.parse(historyRec.bbox_info);
      } catch (e) {
        console.log(historyRec.bbox_info);
        console.error('Error parsing bbox_info for rec ' + historyRec.history_id, e);
      }
    }

    // if (historyRec.tracks_count > 0) {
    //   if (historyRec.tracker_data) {
    //     for (let b of historyRec.tracker_data) {
    //       bb_data.push({ c: b.class_name, x: b.bbox[0] / 1920, y: b.bbox[1] / 1080, w: ((b.bbox[2] - b.bbox[0]) / 1920), h: (b.bbox[3] - b.bbox[1]) / 1080 });
    //     }
    //   }
    // }

    let zone_selected = user.zone_selected;
    let object_detection = zone_selected && zone_selected.location_config ? zone_selected.location_config.feature_controls && zone_selected.location_config.feature_controls.motion_detection && zone_selected.location_config.feature_controls.motion_detection.enabled : true;

    if (bb_data && object_detection !== false) {
      try {

        for (var bb of bb_data) {
          var w = $(currentImage).parent().width()
          var h = $(currentImage).parent().height();

          var div = document.createElement('div');
          div.className = 'bbox bbox_' + bb.c;
          var leftVal = (w * bb['x']);
          if (leftVal < 0) {
            leftVal = 0;
            bb['w'] = bb['w'] + (-bb['x'])
          }
          var widthVal = (w * bb['w']);
          if (widthVal > w) {
            widthVal = w;
          }
          div.setAttribute("style", "position: absolute; border: 2px solid #1dec23; width:" + widthVal + "px; height:" + (h * bb['h']) + "px; top:" + (h * bb['y']) + "px; left:" + leftVal + "px")
          $(div).appendTo($(currentImage).parent());
        }

      } catch (e) { }
    }
  };

  let fetchVehicleTrackingInfo = async (slidePos) => {
    if (!history_recs || !history_recs.length > 0 || !history_recs[slidePos])
      return;

    if (history_recs && history_recs[slidePos] && history_recs[slidePos].tracker_json) {
      //console.log('Tracking info exists for ' + history_recs[slidePos].sec_timestamp);
      return;
    }

    if (!history_recs[slidePos].tracks_count || history_recs[slidePos].tracks_count < 1) {
      //console.log('Tracking info not required for ' + history_recs[slidePos].sec_timestamp);
      return;
    }

    //console.log('Fetching Tracking info for ' + history_recs[slidePos].sec_timestamp);
    let history_id = history_recs[slidePos].history_id;

    var data = {
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      location_id: user.zone_selected.location_id,
      sec_timestamp: history_recs[slidePos].sec_timestamp,
      bbox_category: 'vehicle'
    };
    CommonUtils.ajax(
      {
        url: API.DATA.BOUNDING_BOXES,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          let history_rec = JSON.parse(JSON.stringify(history_recs));
          if (history_id === history_rec[slidePos].history_id)
            history_rec[slidePos].tracker_json = res.data.length > 0 ? res.data[0].tracker_json_new : [];
          setHistoryRecs(history_rec);
        }
      },
      (res) => {
      });
  }

  let applyVideoBoundingBoxes = (bb_data) => {
    try {
      $('.bbox-vehicle').remove();
      let currentImage = $('#video-player');
      for (var bb of bb_data) {
        var w = $(currentImage).parent().width()
        var h = $(currentImage).parent().height();

        var div = document.createElement('div');
        div.className = 'bbox bbox-vehicle bbox_' + bb.c;
        var leftVal = (w * bb['x']);
        if (leftVal < 0) {
          leftVal = 0;
          bb['w'] = bb['w'] + (-bb['x'])
        }
        var widthVal = (w * bb['w']);
        if (widthVal > w) {
          widthVal = w;
        }
        div.setAttribute("style", "position: absolute; border: 2px solid #1dec23; width:" + widthVal + "px; height:" + (h * bb['h']) + "px; top:" + (h * bb['y']) + "px; left:" + leftVal + "px")
        $(div).appendTo($(currentImage).parent());
      }
    } catch (e) { }
  }

  let prepareVideoBoundingBoxes = async () => {
    var historyRec = history_recs && history_recs[slidePos];
    if (historyRec && historyRec.tracks_count > 0) {
      if (!historyRec.tracker_json) {
        return
      }

      let tracker_json = historyRec.tracker_json;
      let fps = 1000 / (tracker_json.rate_fps || 2);

      for (const td of tracker_json.tracker_data) {
        let bb_arr = [];
        for (const b of td.trackers) {
          bb_arr.push({ c: b.class_name, x: b.bbox[0] / 1920, y: b.bbox[1] / 1080, w: ((b.bbox[2] - b.bbox[0]) / 1920), h: (b.bbox[3] - b.bbox[1]) / 1080 });
        }
        setTimeout(() => {
          applyVideoBoundingBoxes(bb_arr);
        }, fps * td.frame_id);
      }
    }
  }

  const initialLoadRef = useRef(true);
  useEffect(() => {
    if (!history_recs || history_recs.length === 0) return;
    if (!initialLoadRef.current) return;
    initialLoadRef.current = false;

    const lastRec = history_recs[history_recs.length - 1];
    const isAi = pendingAiScrollRef.current !== null && pendingAiScrollRef.current > -1;
    const targetRecordId = isAi ? pendingAiScrollRef.current : lastRec.record_id;
    if (isAi) pendingAiScrollRef.current = null;

    // Select the target record immediately so yellow border renders on first paint
    setSlidePos(targetRecordId);

    const waitForSliders = () => {
      const thumbSlider = $('.image-thumbnail-slider')[0];
      const chartSlider = $('.chart_slider')[0];
      // Wait until sliders exist and thumbnailWidth state has been calculated
      if (!thumbSlider || !chartSlider || thumbnailWidthRef.current <= 0)
        return requestAnimationFrame(waitForSliders);

      if (isAi) {
        scrollToPosition(targetRecordId);
      } else {
        const n = history_recs.length;
        const tw = thumbnailWidthRef.current; // containerWidth / 6, known before images load
        const bw = 50;                        // chart bars are always 50px
        syncingScrollRef.current = true;
        thumbSlider.scrollLeft = n * tw;
        chartSlider.scrollLeft = n * bw;
        setTimeout(() => { syncingScrollRef.current = false; }, 200);
      }
    };

    requestAnimationFrame(waitForSliders);
  }, [history_recs]);


  let loadHighResolutionImage = (image, thumbnailFallback) => {
    let ZoneImageObj = document.getElementById('zone-image');

    // Create a temporary image to test if high-res loads
    const testImg = new Image();

    testImg.onload = () => {
      // High-res loaded successfully, update the main image
      ZoneImageObj.setAttribute('src', image);
    };

    testImg.onerror = () => {
      // High-res failed to load, keep the thumbnail
      console.warn('Failed to load high-resolution image, reverting to thumbnail:', image);
      if (thumbnailFallback) {
        ZoneImageObj.setAttribute('src', thumbnailFallback);
      }
    };

    testImg.src = image;
  }

  let playBtnClick = (e) => {
    $(e.target).closest('div').find('img').trigger('click');
  }

  let zoomIfMobile = () => {
    if ($(window).width() <= 768) { // max ipad size
      $('#zoom-control').trigger('click');
    }
  }

  let isWorkHours = (timestamp, site) => {

    let isWorkHour = false;
    let timezone = site.site_iana_timezone;
    if (!timezone)
      timezone = moment.tz.guess();

    // console.log('Checking work hour for timestamp ' + timestamp + ' in timezone ' + timezone);
    if (holidays && holidays.length > 0) {
      let date = moment.tz(timestamp * 1000, timezone).format('YYYY-MM-DD');
      let isHoliday = holidays.find(h => h.date === date);
      //console.log('Checking if ' + date + ' is holiday ? ', isHoliday);
      if (isHoliday)
        return false;
    }

    let time = moment.tz(timestamp * 1000, timezone).format('HH:mm');
    let day = moment.tz(timestamp * 1000, timezone).format('dddd');

    let workHours = site.site_config.work_hours;
    if (workHours.extended_enabled) {
      for (const weekdays in workHours.work_schedule) {
        let event_day = day.toLowerCase();
        if (weekdays === event_day) {
          let work_hours = workHours.work_schedule[event_day];

          let HH = moment.tz(timestamp * 1000, timezone).format('HH');
          let mm = moment.tz(timestamp * 1000, timezone).format('mm');

          let wh_pos = parseInt(HH);
          if (work_hours.length > 24) {
            wh_pos = 2 * wh_pos;
            if (mm > 30)
              wh_pos = wh_pos + 1;
          }

          isWorkHour = work_hours[wh_pos] === 1;
          //console.log(HH + ':' + mm + ' is work hour ? ' + isWorkHour);
        }
      }
    } else {
      if (time > workHours.work_hours_start && time < workHours.work_hours_end) {
        let weekDay = workHours.include_weekends === "6" ? "saturday" : (workHours.include_weekends === "7" ? "sunday" : workHours.include_weekends === "6 7" ? "both" : "none");
        let todayDay = day.toLowerCase();
        if (todayDay !== weekDay) {
          if (weekDay === "both" || (weekDay === "none" && todayDay !== "saturday" && todayDay !== "sunday") || (todayDay !== "saturday" && todayDay !== "sunday")) {
            isWorkHour = true;
          }
        } else {
          isWorkHour = true;
        }
      } else {
        isWorkHour = false;
      }
    }
    return isWorkHour;
  }

  let createPattern = (color = 'black') => {
    // create a 10x10 px canvas for the pattern's base shape
    let shape = document.createElement('canvas')
    shape.width = 5
    shape.height = 5
    // get the context for drawing
    let c = shape.getContext('2d')
    // draw 1st line of the shape 
    c.strokeStyle = color
    c.beginPath()
    c.moveTo(1, 0)
    c.lineTo(5, 4)
    c.stroke()
    // draw 2nd line of the shape 
    c.beginPath()
    c.moveTo(0, 4)
    c.lineTo(1, 5)
    c.stroke()
    // create the pattern from the shape
    return c.createPattern(shape, 'repeat')
  }

  let iOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  let content = null

  if (history_recs) {
    let zoneRecTimeStamp = '';
    let historyRec = history_recs.length > 0 ? (history_recs[slidePos] || history_recs[0]) : null;

    let sensorData = [];
    let sensorInfo = {};
    var sensorCombi = {};
    var sensorCount = 0;
    if (historyRec) {
      sensorData = historyRec.sensor_info ? JSON.parse(historyRec.sensor_info) : [];
      for (let s of sensorData) {
        let combi = (s.device_id + '-' + s.name);
        let d = sensorCombi[combi];
        if (!d) {
          d = sensorCombi[combi] = (s.device_id === s.name) ? 'Gateway' : 'Sensor ' + (++sensorCount);
        }

        if (!sensorInfo[d])
          sensorInfo[d] = [];

        sensorInfo[d].push(s); // Store object with device id.
        if (s.sensor_id === 'temperature' || s.sensor_id === 'humidity') {
          if (!historyRec[s.sensor_id] || d === 'Gateway') // overwrite if gateway
            historyRec[s.sensor_id] = (Math.round(s.value, 2));
        }
      }
      zoneRecTimeStamp = moment.tz(historyRec.sec_timestamp * 1000, timezone).format('MMM DD, YYYY HH:mm');
    }

    fetchVehicleTrackingInfo(slidePos);
    content = history_recs && history_recs.length > 0 ? (
      <div className="p-2">
        <div className="row">
          <div className="col-md-12 p-0">

            <div className="hover-transparent" style={{ position: "absolute", margin: "-1px", background: '#ffffff', textAlign: 'left', padding: '5px 15px', minWidth: user.zone_selected.location_device_type ? (window.innerWidth > 1000 ? '230px' : '0px') : '0px' }}>
              <span className="text-dark font-size-14" style={{ fontSize: "14px" }}>{moment.tz(historyRec && historyRec.sec_timestamp * 1000, timezone).format('MMM DD, YYYY  HH:mm:ss')}</span>
              <span className='font-size-12 ml-4'>

                <span className="text-primary ml-2">
                  {CommonUtils.formatSensorData('temperature', historyRec && historyRec.temperature)}
                </span>
                <span className="ml-3 text-primary ml-1 text-info">
                  {CommonUtils.formatSensorData('humidity', historyRec && historyRec.humidity)}
                </span>
              </span>
            </div>

            <span onClick={() => onPrevClick()} className="cursor-pointer align-vc" >
              <i className='fa fa-lg fa-chevron-left text-light px-2'></i>
            </span>

            <span onClick={() => onNextClick()} className="cursor-pointer align-vc" style={{ right: '0px' }}>
              <i className='fa fa-lg fa-chevron-right text-light px-2'></i>
            </span>

            {historyRec && historyRec.video &&
              <span className="onplay-video-hide video-btn" style={{ position: 'absolute', width: '50px', left: 0, right: 0, margin: 'auto', top: '50%' }}>
                <Modal ref={video_ref} size="modal-dialog modal-xl" title={historyRec.tracks_count > 0 ? historyRec.tracker_json && <img className='cursor-pointer video-icon' style={{ position: 'relative', zIndex: 100 }} alt="" src={video_icon} height="48"></img> : <img className='cursor-pointer video-icon' style={{ position: 'relative', zIndex: 100 }} alt="" src={video_icon} height="48"></img>}>
                  <>
                    <button type="button" style={{ position: 'absolute', zIndex: 2000, right: '0px', margin: '5px', width: '30px' }} className='btn btn-sm btn-danger' data-dismiss="modal" aria-label="Close" onClick={() => video_ref.current && video_ref.current.closeModal()}>X</button>
                    <video id="video-player" onPlaying={(e) => prepareVideoBoundingBoxes()} width="100%" controls autoPlay="autoplay" src={historyRec.video} />
                  </>
                </Modal>
              </span>
            }

            {
              is_axis_camera && CommonUtils.hasPermission('SITESUPT-UI-DVR-DETAILS') && <span data-toggle="tooltip" title="DVR Details" style={{ position: 'absolute', paddingTop: '4px', right: '160px', zIndex: 400 }}>
                <button className="btn btn-sm btn-primary mr-1 ml-2" onClick={() => getDVRDetails()}><i className="fa fa-compact-disc"></i> DVR</button>
              </span>
            }

            <Modal tooltip-title="Zoom Image" ref={React.createRef()} size="modal-dialog modal-fullscreen-70" style={{ position: 'absolute', paddingTop: '4px', right: '40px', zIndex: 400 }} title={<span className='btn btn-sm btn-primary mr-1 ml-2' onClick={(e) => { $(e.target).find('i').trigger('click') }}><span id="zoom-control"><i className='fa fa-search-plus color-white'></i></span></span>}>
              <ZoneHistoryImage zone_name={user.zone_selected.location_name} zone_hisory_rec={historyRec} zone_rec_timestamp={zoneRecTimeStamp} />
            </Modal>

            <span style={{ position: 'absolute', paddingTop: '4px', right: '0px', zIndex: 400 }} data-toggle="tooltip" title="Download Image">
              <span className='btn btn-sm btn-primary mr-1 ml-2' onClick={(e) => { $("[data-toggle='tooltip']").tooltip('hide'); $(e.target).find('i').trigger('click'); }}>
                <a href={historyRec && historyRec.image}><i className='fa fa-download color-white'></i></a>
              </span>
            </span>

            <Swipeable
              trackMouse
              preventDefaultTouchmoveEvent
              onSwipedLeft={onNextClick}
              onSwipedRight={onPrevClick}
            >
              <div id="image_container" >
                <div className="align-vc" style={{ textAlign: 'center', width: '100%' }}>
                  {/* {img_loading && <Loading className="text-white"><span className="text-white">Loading high resolution image ...</span></Loading>} */}
                </div>
                <img sec_timestamp={historyRec && historyRec.sec_timestamp} onClick={zoomIfMobile} id="zone-image" onLoad={(e) => {
                  if (historyRec.image_thumbnail) {
                    if (e.target.src.includes('thumb') || e.target.src.includes('data:image')) { applyBoundingBoxes(); }
                    if (e.target.src.includes('thumb')) { loadHighResolutionImage(historyRec.image, historyRec.image_thumbnail); }
                  }
                }} className='card-img-top' src={historyRec ? historyRec.image_thumbnail || no_image : ''} alt='' />
              </div>
            </Swipeable>
          </div>
          <div className="col-md-12 p-0">
            <div className="row">
              <div className="col-md-12">
                <div className="image-thumbnail-slider" style={{ overflowX: 'scroll', whiteSpace: 'nowrap' }}>
                  <Swipeable
                    trackMouse
                  // onSwipedLeft={onSwipeClickNext}
                  // onSwipedRight={onSwipeClickPrev}
                  >
                    {
                      history_recs.map((zoneRec, recs_pos) => (
                        <LazyLoadImage
                          key={`${zoneRec.record_id}-${zoneRec.image_thumbnail}`}
                          id={"img_thumbnail_" + zoneRec.record_id}
                          pos={zoneRec.record_id}
                          onClick={onImageThumbnailClick}
                          containerClassName={zoneRec && zoneRec.video ? 'd-inline video_thumbnail' : 'd-inline'}
                          className={'cursor-pointer img_thumbnail ' + (slidePos === zoneRec.record_id ? ' border border-warning border-2 curr-image-thumbnail' : ' border border-white border-2')}
                          width={thumbnailWidth}
                          isLoading={!zoneRec.image_thumbnail}
                          path={zoneRec.image_thumbnail || no_image}
                          content={zoneRec && zoneRec.video &&
                            <img t={zoneRec.sec_timestamp} className='play-btn' onClick={playBtnClick} src={video_icon} with="24" height="18" alt=""></img>
                          } />
                      ))
                    }
                  </Swipeable>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {datasets && datasets.length > 0 &&
                  <div className="chart_slider" style={{ overflowX: "scroll" }}>
                    <div style={{ width: `${(labels.length * 50) + 'px'}` }}>
                      <div className='sitekick-chart'>
                        {datasets.map((d, i) => {
                          if (!history_recs[i]) return null;
                          const { has_video, people: persons, vehicle: trucks, is_work_hrs } = d;

                          let p = (persons / maxSize) * 100;
                          let t = (trucks / maxSize) * 100;
                          let v = (has_video / maxSize) * 100;

                          let p_t = p + t;

                          let pt = [];
                          if (p > t) {
                            pt = [
                              <div key={'persons'} w={persons} className='bar text-center' style={{ background: COLORS.PEOPLE, height: (p_t + 1 - t) + '%' }}>{p > 0 && <i className="fas text-white fa-walking"></i>}</div>,
                              <div key={'trucks'} w={trucks} className='bar text-center' style={{ background: COLORS.VEHICLE, height: (p_t - p) + '%', marginTop: '0px' }}>{t > 0 && <i className="fas text-white fa-car"></i>}</div>
                            ]
                          } else {
                            pt = [
                              <div key={'trucks'} w={trucks} className="bar text-center" style={{ background: COLORS.VEHICLE, height: (p === t ? 1 : p_t + 1 - p) + '%' }}>{t > 0 && p !== t && <i className="fas text-white fa-car"></i>}</div>,
                              <div key={'persons'} w={persons} className="bar text-center" style={{ background: COLORS.PEOPLE, height: (p_t - t) + '%', marginTop: '0px' }}>{p > 0 && <i className="fas text-white fa-walking"></i>} {t > 0 && p === t && <i className="fas text-white fa-car"></i>}</div>
                            ]
                          }

                          const isOffWorkHrs = !is_work_hrs;
                          let pClass = isOffWorkHrs ? 'off-workhrs-bg' : 'workhrs-bg';
                          let tooltipContent = (
                            <div key={'tooltip' + i} className='text-left text-black'>
                              <div><i className="far fa-clock"></i> {labels[i]}</div>
                              {persons > 0 && <div>{isOffWorkHrs ? <i className='fa fa-square fa-lg' style={{ color: COLORS.PEOPLE }} /> : <i className="fa fa-square fa-lg " style={{ color: COLORS.PEOPLE }} ></i>} Persons: {persons}</div>}
                              {trucks > 0 && <div>{isOffWorkHrs ? <i className='fa fa-square fa-lg' style={{ color: COLORS.VEHICLE }} /> : <i className="fa fa-square fa-lg " style={{ color: COLORS.VEHICLE }} ></i>} Vehicles: {trucks}</div>}
                            </div>);
                          let isMobile = $('.menu_bars')[0].offsetLeft > 0 || navigator.userAgent.match(/iPad/i) || iOS();
                          return <Tooltip trigger={isMobile ? 'click' : 'hover'} overlayClassName={"chart-tooltip"} key={"bar" + i} arrow={"true"} placement="top" title={tooltipContent}>
                            <div w={maxSize} onClick={() => scrollToPosition(history_recs[i].record_id, 'chart')} pos={history_recs[i].record_id} className={'bar parent-bar ' + pClass} style={{ height: '100%', border: '1px solid ' + (slidePos === history_recs[i].record_id ? 'orange' : '#2c2e33') }}>
                              {has_video > 0 && <div height={v + '%'} className='iceberg' w={has_video}></div>}
                              {pt}
                              <div style={{ margin: "-1px" }} className="bg-white text-center text-app">{labels[i]}</div>
                              <div className='hide'>{tooltipContent}</div>
                            </div>
                          </Tooltip>
                        })}
                      </div>

                    </div>
                  </div>
                }
              </div>

            </div>
            <div className="row">
              <div className='col-12 text-center'><b>Hour</b></div>
            </div>
            <div className="row pt-2">
              <div className="col-md-12 mt-2 pl-4 text-app text-center">
                <label className='mr-3'>People: <i className="fa fa-square fa-lg" style={{ color: COLORS.PEOPLE, cursor: "auto" }}></i></label>
                <label className='mr-3'>Vehicle: <i className="fa fa-square fa-lg" style={{ color: COLORS.VEHICLE, cursor: "auto" }}></i></label>
                <label className='mr-3'>Video: <img src={video_icon} alt='' style={{ width: "24px", height: "18px", paddingBottom: "2px" }}></img></label>
                <label className='mr-3'>Work Hours: <button style={{ minWidth: '18px', 'width': '18px', height: '18px', display: 'inline', cursor: "auto" }} className="btn striped1">&nbsp;</button> </label>
                <label className='mr-3'>Off-Work Hours: <i className="fa fa-square fa-lg" style={{ color: COLORS.WORK, cursor: "auto" }}></i></label>
              </div>
            </div>

            <div className='p-0 mt-3'>
              {
                historyRec && historyRec.sensor_info && !props.hideNotification &&
                <table width="100%" className='table table-striped table-custom table-bordered border-radius-tb'>
                  <thead className='text-white bg-primary'>
                    <tr>
                      <th width='150px'>Notification Type</th>
                      <th>Detail</th>
                    </tr></thead>
                  <tbody className='text-dark bg-white font-size-13'>
                    {
                      Object.keys(sensorInfo).sort(function (a, b) {
                        var x = (a === 'Gateway') ? 'A' + a : a;
                        var y = (b === 'Gateway') ? 'A' + b : b;
                        return x > y ? 1 : (x < y ? -1 : 0);
                      }).map((device_id, d) => (
                        sensorInfo[device_id].sort(function (x, y) {
                          var sortOrder = ['temperature', 'humidity', 'person', 'motion', 'co', 'co2', 'voc'];
                          var a = sortOrder.indexOf(x.sensor_id.toLowerCase());
                          var b = sortOrder.indexOf(y.sensor_id.toLowerCase());
                          return a < b ? -1 : a > b ? 1 : 0;
                        }).map((sensor_rec, s) => {
                          let rec = (
                            <tr key={s}>
                              <td className='text-capitalize'>{(['co', 'co2', 'voc'].indexOf(sensor_rec.sensor_id) !== -1) ? sensor_rec.sensor_id.toUpperCase() : sensor_rec.sensor_id}</td>
                              <td>
                                {sensor_rec.sensor_id === 'person' && (sensor_rec.value === 'People detected' ? 'Core Crew Member' : sensor_rec.value)}
                                {sensor_rec.sensor_id === 'motion' && (sensor_rec.value === '0' ? 'Off' : sensor_rec.value.length === 10 ? moment.tz(parseInt(sensor_rec.value) * 1000, timezone).format('MMM DD, YYYY HH:mm') : zoneRecTimeStamp)}

                                {(sensor_rec.sensor_id === 'co' || sensor_rec.sensor_id === 'voc' || sensor_rec.sensor_id === 'co2' || sensor_rec.sensor_id === 'humidity' || sensor_rec.sensor_id === 'temperature') && (Math.round(sensor_rec.value, 2) === -100 ? "NA" : Math.round(sensor_rec.value, 2))}
                                {sensor_rec.sensor_id === 'temperature' ? Math.round(sensor_rec.value, 2) === -100 ? '' : ' °F' :
                                  sensor_rec.sensor_id === 'humidity' ? Math.round(sensor_rec.value, 2) === -100 ? '' : ' %' :
                                    sensor_rec.sensor_id === 'co2' ? ' ppm' :
                                      sensor_rec.sensor_id === 'co' ? ' ppm' :
                                        sensor_rec.sensor_id === 'voc' ? ' ppb' : ''}
                              </td>
                            </tr>
                          );

                          return s === 0 ? (
                            <React.Fragment key={s}>
                              <tr>
                                <td className="font-weight-bold">{device_id} <span className='pull-right'>{sensor_rec.device_id !== sensor_rec.name && <ZoneSensorBattery sensor_name={sensor_rec.name} />}</span></td>
                                <td>
                                  <div className="row">
                                    <div className={device_id === 'Gateway' ? 'hide' : 'col-md-3'}><b>Name</b>: {sensor_rec.name}</div>
                                    <div className="col-md-6"><b>Last Update</b>: {sensor_rec.lastupdate ? moment.tz(sensor_rec.lastupdate * 1000, timezone).format('YYYY-MM-DD HH:mm') :
                                      moment.tz(sensor_rec.when * 1000, timezone).format('YYYY-MM-DD HH:mm')}</div>
                                  </div>
                                </td>
                              </tr>
                              {!user.zone_selected.location_device_type && rec}
                            </React.Fragment>

                          ) :
                            !user.zone_selected.location_device_type && rec
                        })
                      ))
                    }
                  </tbody>
                </table>
              }
            </div>
          </div>
        </div >
      </div >
    ) : ' Zone History Not Found!';
  }
  return (
    <div className="row bg-white border-rounded">
      <div className="col-lg-12" id="carousel_container">
        {content || <div className='pt-2'><Loading> Fetching Zone History ...</Loading></div>}
      </div>
    </div>
  )
}

export default ZoneHistoryCarousel;